module.exports = "<div ng-if=\"$ctrl.routeType === 'climbing'\"> <ng-include src=\"'app/route/edit/segmentdetails/partial_climbing.html'\"></ng-include> </div> <div ng-if=\"$ctrl.routeType !== 'climbing'\"> <ng-include src=\"'app/route/edit/segmentdetails/partial_others.html'\"></ng-include> </div> <app-photo-edit photo-list=$ctrl.segment.photos main-lang=$ctrl.mainLang ng-if=\"$ctrl.segment.type === 'course'\" on-crop-change=\"$ctrl.cropChanged(id, crop)\"> </app-photo-edit> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/segmentdetails/partial.html
// module id = 480
// module chunks = 0